import { schema } from 'normalizr';
import { membershipConcernListSchema } from './membershipConcern';

export const pnmSchema = new schema.Entity('pnm', {
  membershipConcerns: membershipConcernListSchema,
});

export const pnmListSchema = [pnmSchema];
